import React from 'react';
import styled from 'styled-components';
import { ButtonIcon, IUserProps, User } from 'components';
import { theme, toRem } from 'design';

// Sidebar
export const AddedList = styled.ul`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  height: auto;
  list-style: none;
  padding: 0 ${toRem(22)};

  @media (min-width: ${theme.breakpoint.small}px) {
    padding: 0 ${toRem(theme.layout.gutter.large)};
  }

  @media (min-width: ${theme.breakpoint.large}px) {
    padding: 0;
  }

  @-moz-document url-prefix() {
    @media (min-width: ${theme.breakpoint.large}px) {
      padding-bottom: ${toRem(theme.sidebar.footer.height.large)};
    }
  }
`;

const AddedListItemLayout = styled.li`
  display: flex;
  flex-shrink: 0;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${toRem(72)};
  margin-bottom: ${toRem(11)};
  padding: 0 ${toRem(22)};
  border-radius: ${toRem(5.5)};
  background-color: ${theme.color.white};
  word-break: break-word;
  overflow-wrap: anywhere;

  &:last-child {
    margin-bottom: 0;
  }
`;

interface IAddedListItemProps extends IUserProps {
  className?: string;
  isLoading?: boolean;
  onRemove?: (id: string) => void;
}

export const AddedListItem = ({ className, hasPaymentMethod, id, image, isLoading, onRemove, username, role, site, ...rest }: IAddedListItemProps) => (
  <AddedListItemLayout className={className} {...rest}>
    <User id={id} username={username} image={image} site={site} role={role} hasPaymentMethod={hasPaymentMethod} isLoading={isLoading} stackable={false} />

    <ButtonIcon data-cy="remove-btn" label={`Remove ${username} from payees.`} icon="Close" appearance="secondary" size="small" onClick={() => onRemove && onRemove(id)} />
  </AddedListItemLayout>
);
